import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import classList from 'flarum/common/utils/classList';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';

// flarum/tags puts the current tag's slug in the list params and the search params as `tags`.
const isWishList = tag => !!tag && tag.toLowerCase() === app.forum.attribute('wishVotesWishTag').toLowerCase();
export default function addWishListToolbar() {
  extend(DiscussionListState.prototype, 'sortMap', function (map) {
    // `params` is protected on the list state.
    if (!isWishList(this.params.tags)) return;
    map.mostWishVotes = {
      sort: '-wishVoteCount',
      label: app.translator.trans('awaresoft-wish-votes.forum.sort_most_votes')
    };
    map.mostWishVoters = {
      sort: '-wishVoterCount',
      label: app.translator.trans('awaresoft-wish-votes.forum.sort_most_people')
    };
  });
  extend(IndexPage.prototype, 'viewItems', function (items) {
    const params = app.search.state.params();
    if (!isWishList(params.tags) || !app.forum.attribute('canWishVote')) return;
    const active = !!params.filter?.wishVoted;
    items.add('wishVotesLeft', m("span", {
      className: "WishVotesToolbar-left"
    }, app.translator.trans('awaresoft-wish-votes.forum.toolbar_left', {
      left: app.session.user.wishVotesLeft(),
      allowance: app.forum.attribute('wishVotesAllowance')
    })), -10);
    items.add('wishVotesMine', m(Button, {
      className: classList('Button', {
        active
      }),
      icon: "far fa-star",
      "aria-pressed": active ? 'true' : 'false',
      onclick: () => {
        // params() already hands out a copy, so the route's own params stay untouched.
        const filter = {
          ...params.filter
        };
        if (active) delete filter.wishVoted;else filter.wishVoted = '1';
        setRouteWithForcedRefresh(app.route(app.current.get('routeName'), {
          ...params,
          filter
        }));
      }
    }, app.translator.trans('awaresoft-wish-votes.forum.my_votes')), -20);
  });
}